import { ButtonType, DialogFooterButtonsWidget } from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle } from '~src/commonInfra/dialogs/style/DialogStyles';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { MapDispatchToProps } from '~src/commonInfra/utils/ConnectUtils';

import { getCredentialEncryptionKeyRequest } from '../actions/GetCredentialEncryptionKeyRequestAction';
import { RestoreSiteEncryptionDataKeyRequest, RestoreSiteEncryptionDataKeyResult } from '../serverApi/requests/RestoreSiteEncryptionDataKeyRequest';
import { activateSiteEncryptionKey } from '../services/CredentialEncryptionKeyService';


export interface KMSKeyRestoreViewOwnProps {
    closeDialog: CloseAndDismiss;
    dataKeyId: string;
}

export interface KMSKeyRestoreViewDispatchProps {
    retrieveCredentialEncryptionKey: () => void;
}

export type KMSKeyRestoreViewProps = KMSKeyRestoreViewOwnProps & KMSKeyRestoreViewDispatchProps;


export interface KMSKeyRestoreViewState {
    isRestoringKey: boolean;
}

export class KMSKeyRestoreViewComponent extends React.PureComponent<KMSKeyRestoreViewProps, KMSKeyRestoreViewState> {

    constructor(props: KMSKeyRestoreViewProps) {
        super(props);
        this.state = {
            isRestoringKey: false,
        };
    }


    public render(): JSX.Element {
        return <>
            <div style={DialogFieldParentStyle}>{Messages.credentialEncryption_KMSKeyRestoreDialog_Description()}</div>
            <div style={DialogFieldParentStyle}>{Messages.credentialEncryption_KMSKeyRestoreDialog_Warning()}</div>
            <ul style={{paddingLeft: '20px'}}>
                <li id="kms-key-restore-terms-1">{Messages.credentialEncryption_KMSKeyRestoreDialog_Warning_1()}</li>
                <li id="kms-key-restore-terms-2">{Messages.credentialEncryption_KMSKeyRestoreDialog_Warning_2()}</li>
            </ul>
            <div id="kms-key-restore-validation-message">
                {Messages.credentialEncryption_KMSKeyRestoreDialog_validation_message()}
            </div>
            <br></br>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                        {
                            buttonType: ButtonType.Primary,
                            showSpinner: this.state.isRestoringKey,
                            children: Messages.credentialEncryption_KMSKeyRestoreDialog_Restore_button(),
                            onClick: () => this.restoreKey(),
                            testId: 'restore-button'
                        }
                    ]}
                />
            </div>
        </>;
    }

    private restoreKey() {
        this.setState({isRestoringKey: true}, () => {
            activateSiteEncryptionKey(new RestoreSiteEncryptionDataKeyRequest({dataKeyId: this.props.dataKeyId}))
            .then((response: RestoreSiteEncryptionDataKeyResult) => {
                if(response?.errors && response.errors.length > 0){
                    ToasterService.instance.pop({ type: ToastType.Error, text: Messages.credentialEncryption_KMSKeyRestoreDialog_FailureToast() });
                } else {
                    ToasterService.instance.pop({ type: ToastType.Success, text: Messages.credentialEncryption_KMSKeyRestoreDialog_SuccessToast() });
                    this.props.retrieveCredentialEncryptionKey();
                }
            })
            .catch(() => {
                ToasterService.instance.pop({ type: ToastType.Error, text: Messages.credentialEncryption_KMSKeyRestoreDialog_FailureToast() });
            }).finally(() => {
                this.setState({isRestoringKey: false});
                this.props.closeDialog.close();
            });
        });
    }
}

const mapDispatchToProps: MapDispatchToProps<KMSKeyRestoreViewDispatchProps> =
  (dispatch) => bindActionCreators({
    retrieveCredentialEncryptionKey: getCredentialEncryptionKeyRequest
  },
  dispatch);

export const KMSKeyRestoreView: React.ComponentClass<KMSKeyRestoreViewOwnProps> =
  connect(undefined, mapDispatchToProps)(KMSKeyRestoreViewComponent);